import { render } from "./ProductSegmentFilter.vue?vue&type=template&id=2ddcf040&scoped=true"
import script from "./ProductSegmentFilter.vue?vue&type=script&lang=js"
export * from "./ProductSegmentFilter.vue?vue&type=script&lang=js"

import "./ProductSegmentFilter.vue?vue&type=style&index=0&id=2ddcf040&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ddcf040"]])

export default __exports__